import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  InputAdornment,
  Link,
  Paper,
  TextField,
  Typography,
  Alert,
} from '@mui/material';
import { Email } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer/Footer';
import apiClient from '../../services/api-client';
import styles from './ForgotPasswordPage.module.css';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  // Clear any existing auth token to prevent redirect loops
  useEffect(() => {
    localStorage.removeItem('token');
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      await apiClient.post('/auth/forgot-password', { email });
      setSuccess(true);
    } catch (err: any) {
      setError(err.response?.data?.detail || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <main className={styles.main}>
        <div className={styles.formContainer}>
          <Paper className={styles.formPaper}>
            <form onSubmit={handleSubmit} noValidate>
              <div className={styles.formHeader}>
                <Typography variant="h6" component="h1">
                  Recuperar Senha
                </Typography>
                <Typography variant="body2">
                  Digite seu e-mail para receber um link de recuperação de senha.
                </Typography>
              </div>

              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}

              {success ? (
                <Alert severity="success" sx={{ mb: 2 }}>
                  Se uma conta existir com este e-mail, você receberá um link para redefinir sua
                  senha.
                </Alert>
              ) : (
                <div className={styles.formFields}>
                  <TextField
                    fullWidth
                    type="email"
                    placeholder="Digite seu e-mail"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                    disabled={loading}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Email sx={{ color: 'var(--acer-green)' }} />
                        </InputAdornment>
                      ),
                      sx: { height: '45px' },
                      inputProps: { style: { fontSize: '15px' } },
                    }}
                  />

                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={loading}
                    className={styles.submitButton}
                  >
                    {loading ? 'Enviando...' : 'Enviar Link de Recuperação'}
                  </Button>

                  <Box textAlign="center" mt={2}>
                    <Link
                      href="#"
                      variant="body2"
                      onClick={e => {
                        e.preventDefault();
                        navigate('/login');
                      }}
                      className={styles.link}
                    >
                      Voltar para o Login
                    </Link>
                  </Box>
                </div>
              )}
            </form>
          </Paper>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ForgotPasswordPage;
